<div class="flex center align blueSweepCard">
  <div class="stretch flex center">
    <img class="moyaLogo" src="/assets/moya_logo_blue.svg" />
  </div>
  <p class="header-description" *ngIf="item">
    You have a pending invite to:
    <br />
    <br />
    <b class="org_name">
      {{ item?.organization.name.trim() }}
    </b>
  </p>
  <div class="action-btns" *ngIf="!processing">
    <button
      mat-button
      class="blueOutlineButton logout"
      (click)="rejectInvitation()"
    >
      REJECT
    </button>

    <button
      mat-raised-button
      class="blueButton"
      appearance="outline"
      (click)="acceptInvitation()"
    >
      ACCEPT
    </button>
  </div>
  <div class="loader" *ngIf="processing">
    <mat-spinner [diameter]="40"></mat-spinner>
  </div>
</div>
